/** Endpoint REST que registra o feedback (backend: services/page_feedback). */
export const PAGE_FEEDBACK_ENDPOINT = '/@page-feedback';

/** Serviço de denúncias, para quem abriu o modal procurando o canal errado. */
export const DENUNCIAS_PATH = '/servicos/mpf-servicos-internas/denuncias';

/** Teto do campo "o que você estava procurando", espelhado no contador e no zod. */
export const SUBJECT_MAX_LENGTH = 70;

export const NOT_FOUND_COPY = {
  title: 'Não encontramos a página que você procura',
  lead: 'Ela pode ter sido removida, ter mudado de endereço ou você digitou a URL incorretamente.',
  support:
    'Enquanto isso, você pode voltar para a página inicial, refazer sua busca abaixo ou nos contar o que procurava — isso ajuda a equipe do MPF a corrigir o site.',
  back: 'Voltar à página anterior',
  home: 'Ir para a página inicial',
  feedback: 'Não encontrei o que procurava',
} as const;

export const FEEDBACK_COPY = {
  title: 'Não encontrou o que precisava?',
  intro:
    'Conte para a equipe do MPF o que você estava procurando. Sua mensagem ajuda a corrigir links quebrados e a melhorar a navegação do site.',
  /**
   * Nota LGPD do design, com o endereço concreto interpolado — é o aviso
   * "info" do formulário, e por isso não há um segundo alerta repetindo que
   * a URL vai junto no envio.
   */
  lgpd: (pagePath: string) =>
    `O endereço da página não encontrada (${pagePath}) é registrado automaticamente para fins de melhoria do site. Nenhum dado pessoal é coletado sem sua autorização, conforme a LGPD.`,
  denunciaPrompt: 'Você está tentando fazer uma denúncia?',
  denunciaLink: 'Acesse aqui',
  submit: 'Enviar sugestão',
  invalidForm: 'Revise os campos destacados antes de enviar.',
  rateLimited:
    'Recebemos muitas mensagens deste dispositivo. Aguarde alguns minutos e tente novamente.',
  genericError:
    'Não conseguimos registrar sua sugestão agora. Tente novamente em instantes.',
  successTitle: 'Sugestão enviada com sucesso',
  successBody:
    'Obrigado! Sua mensagem chegou à equipe do MPF e vai ajudar a corrigir o que estava fora do lugar.',
  errorTitle: 'Não foi possível enviar sua sugestão',
} as const;
